import React from "react";

const AdditionalIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0003 22C11.7103 22 10.5703 20.86 10.5703 18.57V11.43C10.5703 9.14 11.7103 8 14.0003 8H18.5703C20.8603 8 22.0003 9.14 22.0003 11.43V18.57C22.0003 20.86 20.8603 22 18.5703 22H14.0003Z"
        fill="#3D68FF"
      />
      <path
        d="M13.43 6.77C10.81 6.98 9.32 8.66 9.32 11.43V16H5.43C3.14 16 2 14.86 2 12.57V5.43C2 3.14 3.14 2 5.43 2H10C12.29 2 13.43 3.14 13.43 5.43V6.77Z"
        fill="#3055D4"
      />
      <path
        d="M17.2491 14.2511V13.3711C17.2491 12.9611 16.9091 12.6211 16.4991 12.6211C16.0891 12.6211 15.7491 12.9611 15.7491 13.3711V14.2511H14.8691C14.4591 14.2511 14.1191 14.5911 14.1191 15.0011C14.1191 15.4111 14.4591 15.7511 14.8691 15.7511H15.7491V16.6311C15.7491 17.0411 16.0891 17.3811 16.4991 17.3811C16.9091 17.3811 17.2491 17.0411 17.2491 16.6311V15.7511H18.1291C18.5391 15.7511 18.8791 15.4111 18.8791 15.0011C18.8791 14.5911 18.5391 14.2511 18.1291 14.2511H17.2491Z"
        fill="white"
      />
    </svg>
  );
};

export default AdditionalIcon;
